import { render, staticRenderFns } from "./virtual.vue?vue&type=template&id=13d3c979&scoped=true&"
import script from "./virtual.vue?vue&type=script&lang=js&"
export * from "./virtual.vue?vue&type=script&lang=js&"
import style0 from "./virtual.vue?vue&type=style&index=0&id=13d3c979&prod&lang=less&scoped=true&"
import style1 from "./virtual.vue?vue&type=style&index=1&id=13d3c979&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3c979",
  null
  
)

export default component.exports